<script lang="ts">
	import type { BrandLogo, RestaurantGroupsFoodResultPayload } from "$lib/def/landing";
	import { LOCATION_PROPS } from "$lib/serv/locations";
	import { KEY_GROUP } from "../TileStack.svelte";
	import { Vertical } from "$lib/def/verticals";
	import { queryFrom } from "$lib/util/url";

	import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";
	
	export let payload: RestaurantGroupsFoodResultPayload;
	export let brands: BrandLogo[] | undefined;
	export let searchParams: Record<string, string>;

	$: {
		payload.items.forEach((restaurantGroup) => {
			const brand = brands?.find(b => b.restaurant_group_id === restaurantGroup.group_id.toString());
			if (brand?.images.restaurant_logo) restaurantGroup.image_url = brand.images.restaurant_logo.base_url + '/80x80' + brand.images.restaurant_logo.filename
		});
		// payload.items = payload.items.filter((restaurantGroup) => restaurantGroup.image_url?.startsWith('http'));
	}
</script>

<div class="headline-m bold">{payload.name}</div>
<div class="brands">
	{#each payload.items as item}
		<a href={
				queryFrom(searchParams)
					.keep(...LOCATION_PROPS)
					.set(KEY_GROUP, item.group_id)
					.set('vertical', searchParams['search_vertical'] || Vertical.Restaurant)
					.toUrl('/')
		} class="brand">
			<LazyBackgroundImage image={item.image_url} alt={item.group_id.toString()} />
		</a>
	{/each}
</div>